import App from './app';

const app = () => {
  document.getElementById('app').innerHTML = App();
};

app();
